
export class MinaHandelssortimentTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        minaHandelssortiment: "Mina handelssortiment",
        searchHandelssortiment: "Sök Handelssortiment",
        taBort: "Ta bort",
        wildcardSearch: "Sök på handelssortiment och produkter",
        handelssortimentsgrupp: "Handelssortimentsgrupp",
        handelssortiment: "Handelssortiment",
        produkter: "Produkter",
        finnsRedan: "Du har redan detta handelssortiment i din lista.",
        aktiv: "Aktiv",
        save: "Spara",
        close: "Stäng",
        hotkeysSave: "Spara (Ctrl+S)",
        labelProdukt: "Produkter",
        labelAdd: "Lägg till",
        labelSearch: "Sök",
        labelClear: "Rensa",
        labelSearchHandelssortimentsgrupp: "Handelssortimentsgrupp",
        labelSearchHandelssortiment: "Handelssortiment",
        labelSearchProdukt: "Produkt",
        leaveDirtyHeader: "Osparade uppgifter",
        leaveDirtyBody: "Du har inte sparat dina ändringar"
    };
}
